<div class="signup-container d-flex align-items-center justify-content-center min-vh-100">
  <div class="row w-100">

    <!-- LEFT SIDE: Signup Content -->
    <div class="col-lg-6 d-flex align-items-center">
      <div class="signup-content">

        <div class="brand-icon">
          <i class="bi bi-envelope-paper"></i>
        </div>

        <h1>
          Start Your Email API Journey
        </h1>

        <p class="signup-description">
          Get started with MALtech Email API and build reliable,
          scalable email communication for your business.
        </p>

        <div class="signup-benefits">

          <div class="benefit">
            <i class="bi bi-check-lg"></i>
            <span>Reliable transactional email delivery</span>
          </div>

          <div class="benefit">
            <i class="bi bi-check-lg"></i>
            <span>Powerful Email API integration</span>
          </div>

          <div class="benefit">
            <i class="bi bi-check-lg"></i>
            <span>Scalable email infrastructure</span>
          </div>

          <div class="benefit">
            <i class="bi bi-check-lg"></i>
            <span>Easy integration with your application</span>
          </div>
            <div class="benefit">
              <i class="bi bi-currency-exchange"></i>
              <span>Local currency billing options</span>
            </div>

            <div class="benefit">
              <i class="bi bi-file-earmark-text"></i>
              <span>GST/taxation-related invoicing support</span>
            </div>

            <div class="benefit">
              <i class="bi bi-headset"></i>
              <span>Ongoing Technical Support</span>
            </div>

        </div>

        <div class="signup-note">

          <h3>Get started with MALtech</h3>

          <p>
            Tell us about your business and requirements.
            Our team will help you get started with MALtech Email API.
          </p>

        </div>

      </div>
    </div>


    <!-- RIGHT SIDE: FORM -->
    <div class="col-lg-6 d-flex align-items-center justify-content-center">

      <div class="signup-card p-4 shadow-sm w-100">
        <div class="text-center signup mb-4">
          <h2 class="heading-color">Welcome to MALtech!</h2>
          <p>Sign up to access exclusive tools and services.</p>
        </div>

        <!-- Step 1 -->
<form
  *ngIf="currentStep === 1"
  [formGroup]="signupForm"
  (ngSubmit)="onSubmitStep1()"
  novalidate
>
  <div class="row g-4">

    <!-- =====================================================
         FULL NAME
         ===================================================== -->
    <div class="col-md-6">
      <label>
        Full Name<span class="required">*</span>
      </label>

      <input
        type="text"
        class="form-control"
        formControlName="fullName"
        placeholder="Enter your full name"
        (input)="onFullNameInput($event)"
      />

      <small
        class="error"
        *ngIf="
          (f['fullName'].touched || submitted) &&
          f['fullName'].errors?.['required']
        "
      >
        Full Name is required
      </small>

      <small
        class="error"
        *ngIf="
          (f['fullName'].touched || submitted) &&
          f['fullName'].errors?.['pattern']
        "
      >
        Full Name can contain only alphabets and spaces
      </small>
    </div>


    <!-- =====================================================
         COMPANY NAME
         ===================================================== -->
    <div class="col-md-6">
      <label>
        Company Name<span class="required">*</span>
      </label>

      <input
        type="text"
        class="form-control"
        formControlName="companyName"
        placeholder="Enter your Company Name"
        (input)="onCompanyNameInput($event)"
      />

      <small
        class="error"
        *ngIf="
          (f['companyName'].touched || submitted) &&
          f['companyName'].errors?.['required']
        "
      >
        Company Name is required
      </small>

      <small
        class="error"
        *ngIf="
          (f['companyName'].touched || submitted) &&
          f['companyName'].errors?.['pattern']
        "
      >
        Enter a valid company name
      </small>
    </div>


    <!-- =====================================================
         PHONE NUMBER
         ===================================================== -->
    <div class="col-md-6">
      <label>
        Phone Number<span class="required">*</span>
      </label>

      <input
        type="text"
        inputmode="numeric"
        maxlength="10"
        class="form-control"
        formControlName="phoneNumber"
        placeholder="Enter your Phone Number"
        (input)="onPhoneInput($event)"
      />

      <small
        class="error"
        *ngIf="
          (f['phoneNumber'].touched || submitted) &&
          f['phoneNumber'].errors?.['required']
        "
      >
        Phone number is required
      </small>

      <small
        class="error"
        *ngIf="
          (f['phoneNumber'].touched || submitted) &&
          f['phoneNumber'].errors?.['pattern']
        "
      >
        Phone number must be exactly 10 digits
      </small>
    </div>


<!-- =====================================================
     BUSINESS EMAIL
     ===================================================== -->
<div class="col-md-6">
  <label>
    Business Email<span class="required">*</span>
  </label>

  <input
    type="email"
    class="form-control"
    formControlName="businessEmail"
    placeholder="Enter your Business Email"
    (input)="onEmailInput($event)"
  />

  <!-- Required -->
  <small
    class="error"
    *ngIf="
      (f['businessEmail'].touched || submitted) &&
      f['businessEmail'].errors?.['required']
    "
  >
    Email is required
  </small>

  <!-- Invalid Email -->
  <small
    class="error"
    *ngIf="
      (f['businessEmail'].touched || submitted) &&
      f['businessEmail'].errors?.['pattern']
    "
  >
    Enter a valid email address
  </small>
</div>


    <!-- =====================================================
         WEBSITE
         ===================================================== -->
    <div class="col-md-6">
      <label>
        Website<span class="required">*</span>
      </label>

      <input
        type="text"
        class="form-control"
        formControlName="website"
        placeholder="Enter your Website URL"
      />

      <small
        class="error"
        *ngIf="
          (f['website'].touched || submitted) &&
          f['website'].errors?.['required']
        "
      >
        Website is required
      </small>

      <small
        class="error"
        *ngIf="
          (f['website'].touched || submitted) &&
          f['website'].errors?.['pattern']
        "
      >
        Enter a valid website URL
      </small>
    </div>


    <!-- =====================================================
         GST / TAX
         ===================================================== -->
    <div class="col-md-6">
      <label>
        GSTIN / TAX No
      </label>

      <input
        type="text"
        class="form-control"
        formControlName="gst"
        placeholder="Enter your GSTIN / TAX No"
        (input)="onGstInput($event)"
      />

      <small
        class="error"
        *ngIf="
          (f['gst'].touched || submitted) &&
          f['gst'].errors?.['pattern']
        "
      >
        Enter a valid GSTIN / TAX number
      </small>
    </div>


    <!-- =====================================================
         COUNTRY
         ===================================================== -->
    <div class="col-md-6">
      <mat-form-field
        appearance="outline"
        class="full-width state-field w-100"
      >
        <mat-label>Select Country</mat-label>

        <mat-select
          formControlName="country"
          (selectionChange)="onCountryChange($event)"
          (openedChange)="onCountryDropdownOpened()"
        >

          <!-- Country Search -->
          <mat-option class="form-control border-2 bg-light">
            <input
              matInput
              placeholder="Search Country"
              (input)="filterCountries($event)"
              (click)="$event.stopPropagation()"
            />
          </mat-option>

          <mat-option
            *ngFor="let c of filteredCountries"
            [value]="c.id"
          >
            {{ c.name }}
          </mat-option>

        </mat-select>

        <mat-error
          *ngIf="
            signupForm.get('country')?.hasError('required') &&
            (signupForm.get('country')?.touched || submitted)
          "
        >
          Country is required
        </mat-error>

      </mat-form-field>
    </div>


    <!-- =====================================================
         STATE
         ===================================================== -->
    <div class="col-md-6">
      <mat-form-field
        appearance="outline"
        class="full-width w-100 state-field"
      >
        <mat-label>Select State</mat-label>

        <mat-select
          formControlName="state"
          (openedChange)="onStateDropdownOpened()"
        >

          <!-- State Search -->
          <mat-option class="form-control border-2 bg-light">
            <input
              matInput
              placeholder="Search State"
              (input)="filterStates($event)"
              (click)="$event.stopPropagation()"
            />
          </mat-option>

          <mat-option
            *ngFor="let s of filteredStates"
            [value]="s.id"
          >
            {{ s.name }}
          </mat-option>

        </mat-select>

        <mat-error
          *ngIf="
            signupForm.get('state')?.hasError('required') &&
            (signupForm.get('state')?.touched || submitted)
          "
        >
          State is required
        </mat-error>

      </mat-form-field>
    </div>


    <!-- =====================================================
         CITY
         ===================================================== -->
    <div class="col-md-6">
      <label>
        City<span class="required">*</span>
      </label>

      <input
        type="text"
        class="form-control"
        formControlName="city"
        placeholder="Enter your city"
        (input)="onCityInput($event)"
      />

      <small
        class="error"
        *ngIf="
          (f['city'].touched || submitted) &&
          f['city'].errors?.['required']
        "
      >
        City is required
      </small>

      <small
        class="error"
        *ngIf="
          (f['city'].touched || submitted) &&
          f['city'].errors?.['pattern']
        "
      >
        City can contain only alphabets and spaces
      </small>
    </div>


    <!-- =====================================================
         ADDRESS
         ===================================================== -->
    <div class="col-md-6">
      <label>
        Address<span class="required">*</span>
      </label>

<input
  type="text"
  class="form-control"
  formControlName="address"
  placeholder="Enter your Address"
  (input)="onAddressInput($event)"
/>

      <small
        class="error"
        *ngIf="
          (f['address'].touched || submitted) &&
          f['address'].errors?.['required']
        "
      >
        Address is required
      </small>

      <small
        class="error"
        *ngIf="
          (f['address'].touched || submitted) &&
          f['address'].errors?.['minlength']
        "
      >
        Address must be at least 5 characters
      </small>

    </div>


    <!-- =====================================================
         ZIP CODE
         ===================================================== -->
    <div class="col-md-6">
      <label>
        Zip Code<span class="required">*</span>
      </label>

      <input
        type="text"
        inputmode="numeric"
        maxlength="6"
        class="form-control"
        formControlName="zip"
        placeholder="Enter your Zip Code"
        (input)="onZipInput($event)"
      />

      <small
        class="error"
        *ngIf="
          (f['zip'].touched || submitted) &&
          f['zip'].errors?.['required']
        "
      >
        Zip code is required
      </small>

      <small
        class="error"
        *ngIf="
          (f['zip'].touched || submitted) &&
          f['zip'].errors?.['pattern']
        "
      >
        Zip code must be exactly 6 digits
      </small>
    </div>


    <!-- =====================================================
         USERNAME
         ===================================================== -->
    <div class="col-md-6">
      <label>
        Username<span class="required">*</span>
      </label>

      <input
        type="text"
        class="form-control"
        formControlName="username"
        placeholder="Enter your Username"
        (input)="onUsernameInput($event)"
      />

      <small
        class="error"
        *ngIf="
          (f['username'].touched || submitted) &&
          f['username'].errors?.['required']
        "
      >
        Username is required
      </small>

      <small
        class="error"
        *ngIf="
          (f['username'].touched || submitted) &&
          f['username'].errors?.['minlength']
        "
      >
        Username must be at least 4 characters
      </small>

      <small
        class="error"
        *ngIf="
          (f['username'].touched || submitted) &&
          f['username'].errors?.['pattern']
        "
      >
        Username can contain only letters, numbers and underscore
      </small>
    </div>


    <!-- =====================================================
         PASSWORD
         ===================================================== -->
    <div class="col-md-6 position-relative">
      <label>
        Password<span class="required">*</span>
      </label>

      <div class="input-group">
<input
  [type]="showPassword ? 'password' : 'text'"
  class="form-control"
  formControlName="password"
  placeholder="Create a strong password"
  (input)="onPasswordInput($event)"
/>

        <span
          class="input-group-text form ic"
          (click)="togglePassword('password')"
        >
          <i
            class="bi"
            [ngClass]="
              showPassword
                ? 'bi-eye-slash'
                : 'bi-eye'
            "
          ></i>
        </span>

      </div>

      <small
        class="error"
        *ngIf="
          (f['password'].touched || submitted) &&
          f['password'].errors?.['required']
        "
      >
        Password is required
      </small>

      <small
        class="error"
        *ngIf="
          (f['password'].touched || submitted) &&
          f['password'].errors?.['pattern']
        "
      >
        Password must be at least 16 characters and include
        uppercase, lowercase, number, and special character
      </small>

    </div>


    <!-- =====================================================
         CONFIRM PASSWORD
         ===================================================== -->
    <div class="col-md-6 position-relative">
      <label>
        Confirm Password<span class="required">*</span>
      </label>

      <div class="input-group">

       <input
  [type]="showConfirmPassword ? 'password' : 'text'"
  class="form-control"
  formControlName="confirmPassword"
  placeholder="Confirm your password"
  (input)="onConfirmPasswordInput($event)"
/>

        <span
          class="input-group-text ic"
          (click)="togglePassword('confirmPassword')"
        >
          <i
            class="bi"
            [ngClass]="
              showConfirmPassword
                ? 'bi-eye-slash'
                : 'bi-eye'
            "
          ></i>
        </span>

      </div>

      <small
        class="error"
        *ngIf="
          (f['confirmPassword'].touched || submitted) &&
          f['confirmPassword'].errors?.['required']
        "
      >
        Confirm password is required
      </small>

      <small
        class="error"
        *ngIf="
          signupForm.hasError('mismatch') &&
          (f['confirmPassword'].touched || submitted)
        "
      >
        Passwords do not match
      </small>

    </div>


    <!-- =====================================================
         SUBMIT
         ===================================================== -->
    <div class="col-md-12 text-center">

      <button
        type="submit"
        class="btn btn-hover px-5"
        [disabled]="isSubmittingStep1"
      >
        {{
          isSubmittingStep1
            ? 'Submitting...'
            : 'Submit'
        }}
      </button>

    </div>

  </div>
</form>

        <!-- Step 2 -->
        <!-- Step 2 -->
        <!-- Step 2 -->
        <div *ngIf="currentStep === 2">
          <div>
            <form
              [formGroup]="signupFormStep2"
              (ngSubmit)="onSubmitStep2()"
              novalidate
            >
              <div class="row g-3">
                <!-- Email Type -->
                <div class="col-md-6">
                  <label
                    >What type of emails do you send?<span class="required"
                      >*</span
                    ></label
                  >
                  <select class="form-select" formControlName="emailType">
                    <option value="">-- Select --</option>
                    <option value="Transactional Emails">Transactional Emails</option>
                    <option value="Marketing Emails">Marketing Emails</option>
                    <option value="Both">
                      Transactional and Marketing Emails
                    </option>
                  </select>
                  <small
                    class="text-danger"
                    *ngIf="
                      (f2['emailType'].touched || submitted2) &&
                      f2['emailType'].invalid
                    "
                    (click)="touchField('emailType')"
                  >
                    Required field
                  </small>
                </div>

                <!-- Send Method -->
                <div class="col-md-6">
                  <label
                    >How do you send emails via SMTP or API?<span
                      class="required"
                      >*</span
                    ></label
                  >
                  <select class="form-select" formControlName="sendMethod">
                    <option value="">-- Select --</option>
                    <option value="1">SMTP</option>
                    <option value="2">API</option>
                    <option value="3">SMTP & API</option>
                  </select>
                  <small
                    class="text-danger"
                    *ngIf="
                      (f2['sendMethod'].touched || submitted2) &&
                      f2['sendMethod'].invalid
                    "
                    (click)="touchField('sendMethod')"
                  >
                    Required field
                  </small>
                </div>

                <!-- Third Party Service -->
                <div class="col-md-6">
                  <label
                    >Are you using a third-party service?<span class="required"
                      >*</span
                    ></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    placeholder="please enter..."
                    formControlName="thirdPartyService"
                  />
                  <small
                    class="text-danger"
                    *ngIf="
                      (f2['thirdPartyService'].touched || submitted2) &&
                      f2['thirdPartyService'].invalid
                    "
                    (click)="touchField('thirdPartyService')"
                  >
                    Required field
                  </small>
                </div>

                <!-- Primary Use Case -->
                <div class="col-md-6">
                  <label
                    >What is your primary use case?<span class="required"
                      >*</span
                    ></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    placeholder="please enter..."
                    formControlName="primaryUseCase"
                  />
                  <small
                    class="text-danger"
                    *ngIf="
                      (f2['primaryUseCase'].touched || submitted2) &&
                      f2['primaryUseCase'].invalid
                    "
                    (click)="touchField('primaryUseCase')"
                  >
                    Required field
                  </small>
                </div>

                <!-- Email Provider -->
                <div class="col-md-6">
                  <label
                    >Who is your current email service provider?<span
                      class="required"
                      >*</span
                    ></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    placeholder="please enter..."
                    formControlName="emailProvider"
                  />
                  <small
                    class="text-danger"
                    *ngIf="
                      (f2['emailProvider'].touched || submitted2) &&
                      f2['emailProvider'].invalid
                    "
                    (click)="touchField('emailProvider')"
                  >
                    Required field
                  </small>
                </div>

                <!-- Volume Requirement -->
                <div class="col-md-6">
                  <label
                    >What is your volume requirement?<span class="required"
                      >*</span
                    ></label
                  >
                 <input
  type="text"
  inputmode="numeric"
  class="form-control"
  placeholder="Please enter..."
  formControlName="volumeRequirement"
  (input)="onVolumeRequirementInput($event)"
/>
                  <small
                    class="text-danger"
                    *ngIf="
                      (f2['volumeRequirement'].touched || submitted2) &&
                      f2['volumeRequirement'].invalid
                    "
                    (click)="touchField('volumeRequirement')"
                  >
                    Enter a valid number
                  </small>
                </div>

                <!-- Bounce Process -->
                <div class="col-md-6">
                  <label
                    >Do you have a process to handle bounces/unsubscribes?<span
                      class="required"
                      >*</span
                    ></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    placeholder="please enter..."
                    formControlName="bounceProcess"
                  />
                  <small
                    class="text-danger"
                    *ngIf="
                      (f2['bounceProcess'].touched || submitted2) &&
                      f2['bounceProcess'].invalid
                    "
                    (click)="touchField('bounceProcess')"
                  >
                    Required field
                  </small>
                </div>

                <!-- Opt-in Link -->
                <div class="col-md-6">
                  <label
                    >Do you have the opt in and opt out link? If Yes, share the
                    link. If No, update a new opt out link<span class="required"
                      >*</span
                    ></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    placeholder="please enter..."
                    formControlName="optInLink"
                  />
                  <small
                    class="text-danger"
                    *ngIf="
                      (f2['optInLink'].touched || submitted2) &&
                      f2['optInLink'].invalid
                    "
                    (click)="touchField('optInLink')"
                  >
                    Required field
                  </small>
                </div>

                <!-- Permissions -->
                <div class="col-md-6">
                  <label
                    >Have you acquired permissions/licenses for third-party
                    content?<span class="required">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    placeholder="please enter..."
                    formControlName="permissions"
                  />
                  <small
                    class="text-danger"
                    *ngIf="
                      (f2['permissions'].touched || submitted2) &&
                      f2['permissions'].invalid
                    "
                    (click)="touchField('permissions')"
                  >
                    Required field
                  </small>
                </div>

                <!-- Clean List -->
                <div class="col-md-6">
                  <label
                    >How do you plan to maintain a clean email list and remove
                    invalid or inactive email addresses?<span class="required"
                      >*</span
                    ></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    placeholder="please enter..."
                    formControlName="cleanList"
                  />
                  <small
                    class="text-danger"
                    *ngIf="
                      (f2['cleanList'].touched || submitted2) &&
                      f2['cleanList'].invalid
                    "
                    (click)="touchField('cleanList')"
                  >
                    Required field
                  </small>
                </div>

                <!-- Privacy Policy -->
                <div class="col-md-6">
                  <label
                    >Do you have a privacy policy and terms of service
                    accessible to your email recipients?<span class="required"
                      >*</span
                    ></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    placeholder="please enter..."
                    formControlName="privacyPolicy"
                  />
                  <small
                    class="text-danger"
                    *ngIf="
                      (f2['privacyPolicy'].touched || submitted2) &&
                      f2['privacyPolicy'].invalid
                    "
                    (click)="touchField('privacyPolicy')"
                  >
                    Required field
                  </small>
                </div>

                <!-- Anti-Spam -->
                <div class="col-md-6">
                  <label
                    >Are you familiar with anti-spam regulations and best
                    practices relevant to your region?<span class="required"
                      >*</span
                    ></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    placeholder="please enter..."
                    formControlName="antiSpam"
                  />
                  <small
                    class="text-danger"
                    *ngIf="
                      (f2['antiSpam'].touched || submitted2) &&
                      f2['antiSpam'].invalid
                    "
                    (click)="touchField('antiSpam')"
                  >
                    Required field
                  </small>
                </div>
              </div>

              <!-- Terms -->
              <div class="form-check mt-3">
                <input
                  class="form-check-input"
                  type="checkbox"
                  formControlName="agree"
                />
                <label class="form-check-label"
                  >I agree terms and conditions<span class="required"
                    >*</span
                  ></label
                >
                <small
                  class="text-danger"
                  *ngIf="
                    (f2['agree'].touched || submitted2) && f2['agree'].invalid
                  "
                  (click)="touchField('agree')"
                >
                  You must agree before submitting
                </small>
              </div>

              <!-- Submit -->
              <div class="mt-4 text-center">
                <button
  type="submit"
  class="btn btn-hover"
  [disabled]="isSubmittingStep2"
>
  {{ isSubmittingStep2 ? 'Submitting...' : 'SUBMIT' }}
</button>
              </div>
            </form>
        
      </div>

    </div>

  </div>
</div>